<template>
  <div>
    <v-row v-if="loadingTotalizers">
      <v-col cols="12" sm="6" md="6" lg="6" v-for="i in 2" :key="i">
        <v-skeleton-loader type="list-item-three-line" class="mb-3"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row v-if="!!totalizadores && !loadingTotalizers">
      <v-col cols="12" md="6">
        <v-card class="py-3 px-4 vcard_area">
          <v-row>
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">{{totalizadores.total_mes_anterior}}</div>
              <div class="text-h3 mb-2">Tarefas concluídas no mês anterior</div>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area_medium" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>checklist_rtl</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="py-3 px-4 vcard_area">
          <v-row>
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">{{totalizadores.total_mes_atual}}</div>
              <div class="text-h3 mb-2">Tarefas concluídas no mês atual</div>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area_medium" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>fact_check</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Api from '@API'

export default {
  props: ['refresh'],
  watch: {
    refresh () {
      if (!this.refresh) return false
      this.getTotalizers()
      this.$emit('reset-refresh')
    }
  },
  data () {
    return {
      loadingTotalizers: false,
      totalizadores: null,
      atualiza: null
    }
  },
  methods: {
    async getTotalizers () {
      this.loadingTotalizers = true
      await Api.get('tarefas/totalizadores')
        .then(res => {
          if (res.data) {
            this.totalizadores = res.data
          }
          this.loadingTotalizers = false
        })
        .catch(err => {
          this.loadingTotalizers = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os totalizadores!',
            color: 'error'
          })
          console.log(err)
        })
    }
  },
  created () {
    this.getTotalizers()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
</style>



// WEBPACK FOOTER //
// src/pages/tarefas/TotalizadorTarefas.vue